import * as $ from 'jquery';
import 'datatables';

export default (function () {


    // Definindo as traduções com base no locale
    const translations = {
        pt: 'https://cdn.datatables.net/plug-ins/1.10.22/i18n/Portuguese-Brasil.json',
        es: 'https://cdn.datatables.net/plug-ins/1.10.22/i18n/Spanish.json',
        en: 'https://cdn.datatables.net/plug-ins/1.10.22/i18n/English.json'
    };

    // Verificar o locale do usuário (usando o que foi passado do Laravel ou da URL)
    const userLocale = window.locale || 'pt'; // Default para 'pt' se o locale não estiver definido

    // Configurar a URL de tradução com base no locale
    const langUrl = translations[userLocale] || translations['pt']; // Fallback para 'pt' caso não tenha uma tradução

	$.extend(true, $.fn.dataTable.defaults, {
		processing: false,
		language: {
			'url' : langUrl
		},
	});

	
	$('.table')
		.on('processing.dt', function ( e, settings, processing ) {
			let loader = $('#loader');
			if (processing) {
				loader.removeClass('hide');
			} else {
				loader.addClass('hide');
			}
		})

  	$('#dataTable')
		.DataTable({
			aaSorting: []
		});

}());
